import { snakeCase } from 'lodash';

export const CypressIds = {
  // login
  loginEmail: 'login-email',
  loginPassword: 'login-password',
  loginButton: 'login-button',
  loginMicrosoftSSOButton: 'login-microsoft-sso-button',
  loginGoogleSSOButton: 'login-google-sso-button',
  agentMicrosoftSSOButton: 'agent-microsoft-sso-button',
  agentGoogleSSOButton: 'agent-google-sso-button',
  // navbar
  navBarHomePage: 'nav-bar-home-page',
  navBarInsuredsPage: 'nav-bar-insureds-page',
  navBarProjectsPage: 'nav-bar-projects-page',
  navBarReportsPage: 'nav-bar-reports-page',
  navBarTemplatesPage: 'nav-bar-templates-page',
  navBarAdminPage: 'nav-bar-admin-page',
  // nav header
  headerUserCompaniesDropdown: 'header-user-companies-and-logout-action-dropdown',
  logoutButton: 'header-logout-button',
  // ipp
  insuredProfileInsuredHeaderName: 'ipp-insured-profile-insured-header-name',
  insuredProfileCloseDetailsButton: 'ipp-insured-profile-close-details-button',
  insuredProfileSaveDetailsButton: 'ipp-insured-profile-save-details-button',
  insuredOverallStatus: 'ipp-insured-overall-status',
  recordsSection: 'ipp-records-section',
  recordStatusButton: id => `ipp-record-${id}-status-button`,
  requiredPoliciesSection: 'ipp-required-policies-section',
  loadingPolicyGearIcon: 'ipp-loading-policy-gear-icon',
  loadingDocumentGearIcon: 'ipp-loading-document-gear-icon',
  loadedPolicyGearIcon: 'ipp-loaded-policy-gear-icon',
  loadedDocumentGearIcon: 'ipp-loaded-document-gear-icon',
  archivedPoliciesModalButton: 'ipp-archived-policies-modal-button',
  archivedPoliciesModal: 'ipp-archived-policies-modal',
  policyRow: id => `ipp-policy-row-${id}`,
  policyQuestionRequirementIconButton: (policyTypeId, policyId) => `ipp-policy-question-requirement-icon-button_policy-type-${policyTypeId}-policy-${policyId}`,
  questionRequirementModal: 'ipp-question-requirement-modal',
  questionRequirementRow: questionId => `ipp-question-requirement-row-${questionId}`,
  questionRequirementQuestion: questionId => `ipp-question-requirement-question-${questionId}`,
  questionRequirementAnswer: questionId => `ipp-question-requirement-answer-${questionId}`,
  questionRequirementReason: questionId => `ipp-question-requirement-reason-${questionId}`,
  questionRequirementResources: questionId => `ipp-question-requirement-resources-${questionId}`,
  questionRequirementDate: questionId => `ipp-question-requirement-date-${questionId}`,
  questionRequirementMarkAsEmptyIcon: questionId => `ipp-question-requirement-mark-as-empty-icon-${questionId}`,
  policyTypeRow: (policyTypeId, policyId) => `ipp-policy-type-row-${policyTypeId}${policyId ? `-policy-${policyId}` : ''}`,
  policyTypePropertyOption: (policyTypePropertyId, status) => `ipp-policy-type-property-option-${policyTypePropertyId}-status-${status}`,
  policyTypePropertyLimit: (policyTypePropertyId, status) => `ipp-policy-type-property-limit-${policyTypePropertyId}-status-${status}`,
  policyOptionsIconButton: (policyTypeId, policyId) => `ipp-policy-type-row-${policyTypeId}${policyId ? `-policy-${policyId}` : ''}-options-button`,
  policyOptionsUpdatePolicyButton: (policyTypeId, policyId) => `ipp-policy-type-row-${policyTypeId}${policyId ? `-policy-${policyId}` : ''}-update-policy-button`,
  policyOptionsRemoveAgentButton: (policyTypeId, policyId) => `ipp-policy-type-row-${policyTypeId}${policyId ? `-policy-${policyId}` : ''}-remove-agent-button`,
  removeAgentModal: 'ipp-remove-agent-modal',
  policyUpdateModalAgentUpdateWarning: 'ipp-policy-update-modal-warning-agent-update-warning',
  archivedPolicyRow: id => `ipp-archived-policy-row-${id}`,
  archivedPolicyStatusButton: id => `ipp-archived-policy-status-button-${id}`,
  statusButtonValue: (cypressId, status) => `ipp-${cypressId}-status-${snakeCase(status)}`,
  policyStatusButton: (policyTypeId, policyId) => `ipp-policy-requirement-status-button_policy-type-${policyTypeId}-policy-${policyId}`,
  documentRequirementSection: 'ipp-required-documents-section',
  docTypeRow: docTypeId => `ipp-document-requirement-row-${docTypeId}`,
  docQuestionRequirementIconButton: docTypeId => `ipp-document-question-requirement-icon-button_document-type-${docTypeId}`,
  documentRow: docId => `ipp-document-row-${docId}`,
  uploadDocumentButton: docTypeId => `${CypressIds.docTypeRow(docTypeId)}-upload-doc-button`,
  uploadDocDynamicFileInput: 'ipp-upload-doc-dynamic-file-input',
  documentStatusButton: docTypeId => `ipp-document-requirement-status-button_document-type-${docTypeId}`,
  documentStatusButtonOption: (docTypeId, status) => `ipp-${CypressIds.documentStatusButton(docTypeId)}-status-${snakeCase(status)}`,
  documentArchivedModalButton: 'ipp-document-archived-modal-button',
  archivedDocumentsSection: 'ipp-archived-documents-section',
  archivedDocumentRow: docId => `ipp-archived-document-row-${docId}`,
  archivedDocumentRowStatusButton: docId => `ipp-archived-document-row-${docId}-status-button`,
  documentExpiredSection: docId => `ipp-expired-document-section-doc-${docId}`,
  documentExpiredIconButton: docId => `ipp-expired-document-icon-button-doc-${docId}`,
  documentExpiredIconButtonPopover: docId => `ipp-expired-document-icon-button-popover-doc-${docId}`,
  documentFileNameCell: docId => `ipp-expired-document-file-name-cell-doc-${docId}`,
  documentOptionsButton: docId => `ipp-document-options-button-doc-${docId}`,
  documentOptionsLinkToPolicyOption: docId => `ipp-document-options-button-doc-${docId}-link-to-policy-option`,
  documentOptionsEditNameOption: docId => `ipp-document-options-button-doc-${docId}-edit-name-option`,
  editDocumentNameInput: 'ipp-edit-document-name-input',
  updateDocumentNameButton: 'ipp-update-document-name-button',
  documentOptionsArchiveOption: docId => `ipp-document-options-button-doc-${docId}-archive-button`,
  documentOptionsDeleteOption: docId => `ipp-document-options-button-doc-${docId}-delete-button`,
  linkedPolicyDocCheckBox: policyId => `ipp-document-policy-link-checkbox-policy-${policyId}`,
  customDocExpirationDateTextSection: docId => `ipp-document-policy-link-custom-doc-date-section-doc-${docId}`,
  policyDocDatePicker: docId => `ipp-document-policy-datepicker-input-doc-${docId}`,
  confirmPolicyDateButton: 'ipp-document-policy-confirm-button',
  customExpirationsAddButton: docId => `ipp-custom-expirations-add-button-doc-${docId}`,
  customExpirationsDatePicker: docId => `ipp-custom-expirations-datepicker-doc-${docId}`,
  customExpirationsNameInput: docId => `ipp-custom-expirations-name-input-doc-${docId}`,
  customExpirationsNoteInput: docId => `ipp-custom-expirations-note-input-doc-${docId}`,
  customExpirationsScopeTypeSelect: docId => `ipp-custom-expirations-scope-type-select-doc-${docId}`,
  customExpirationsScopeValueSelect: docId => `ipp-custom-expirations-scope-value-select-doc-${docId}`,
  customExpirationsEditRow: expirationId => `ipp-custom-expirations-edit-row-${expirationId}`,
  customExpirationsDeleteRow: expirationId => `ipp-custom-expirations-delete-row-${expirationId}`,
  updateRequirementsButton: 'ipp-update-requirements-button',
  ippCreateCertificateButton: 'ipp-create-certificate-button',
  sendInsuranceRequestEmailButton: 'ipp-send-insurance-request-email-button',
  previewInsuranceRequestEmailButton: 'ipp-insurance-request-preview-email-button',
  overallStatusBarApproved: 'ipp-overall-status-bar-approved',
  overallStatusBarNotApproved: 'ipp-overall-status-bar-not-approved',
  overallStatusBarArchived: 'ipp-overall-status-bar-archived',
  activityLogRefreshButton: 'ipp-activity-log-refresh-button',
  activityLogSection: 'ipp-activity-log-section',
  activityLogBody: 'ipp-activity-log-body',
  // requirements builder
  policyTypeBlock: policyTypeId => `req-builder-policy-type-${policyTypeId}-block`,
  policyTypePropertyRequirementForm: (policyTypeId, propertyId) => `req-builder-policy-type-${policyTypeId}-property-${propertyId}-form`,
  savePolicyRequirementDetailsButton: 'req-builder-save-policy-requirement-details-button',
  policyTypeDeleteButton: policyTypeId => `req-builder-policy-type-${policyTypeId}-delete-button`,
  docTypeBlock: docTypeId => `req-builder-document-type-${docTypeId}-block`,
  docTypeDeleteButton: docTypeId => `req-builder-document-type-${docTypeId}-delete-button`,
  policyTypeMenuOption: id => `req-builder-requirement-policy-type-option-${id}`,
  docTypeMenuOption: id => `req-builder-requirement-doc-type-option-${id}`,
  languageTypeMenuOption: id => `req-builder-requirement-language-type-option-${id}`,
  questionMenuOption: 'req-builder-requirement-question-option',
  recordQuestionPolicyIcon: policyTypeId => `req-builder-policy-type-${policyTypeId}-record-question-icon`,
  recordQuestionDocIcon: docTypeId => `req-builder-document-type-${docTypeId}-record-question-icon`,
  questionCategoryButton: questionCategoryId => `req-builder-question-category-button-${questionCategoryId}`,
  questionCategoryFavoriteButton: questionCategoryId => `req-builder-question-category-favorite-button-${questionCategoryId}`,
  questionButton: questionId => `req-builder-question-button-${questionId}`,
  questionFavoriteButton: questionId => `req-builder-question-favorite-button-${questionId}`,
  questionDeleteButton: questionId => `req-builder-question-delete-button-${questionId}`,
  policyRequirementTypeQuestionLinkCheckbox: policyTypeId => `req-builder-policy-type-${policyTypeId}-question-link-checkbox`,
  docRequirementTypeQuestionLinkCheckbox: docTypeId => `req-builder-document-type-${docTypeId}-question-link-checkbox`,
  saveQuestionRequirementButton: 'req-builder-save-question-requirement-button',
  recordQuestionQuestionName: questionId => `req-builder-question-name-${questionId}`,
  recordQuestionQuestion: questionId => `req-builder-question-question-${questionId}`,
  recordQuestionPolicyLinkDeleteIcon: (policyTypeId, questionId) => `req-builder-question-policy-type-${policyTypeId}-link-delete-icon-${questionId}`,
  recordQuestionDocLinkDeleteIcon: (docTypeId, questionId) => `req-builder-question-document-type-${docTypeId}-link-delete-icon-${questionId}`,
  closeQuestionLinkPolicyTypePopover: policyTypeId => `req-builder-question-policy-type-${policyTypeId}-link-popover-close-button`,
  closeQuestionLinkDocumentTypePopover: docTypeId => `req-builder-question-document-type-${docTypeId}-link-popover-close-button`,
  selectAllRequirementTypeLinkCheckboxes: 'req-builder-select-all-question-requirement-type-link-checkboxes',
  updateRequirementsPageSaveButton: 'req-builder-save-requirements-button',
  // cert flow
  ocrSkipButton: 'cert-submission-ocr-skip-button',
  policyEffectiveDateInput: 'cert-submission-effective-on-date-input',
  policyExpirationDateInput: 'cert-submission-expires-on-date-input',
  policyNumberInput: 'cert-submission-policy-number-input',
  certSubmissionInsuranceCompanyDropdownMenu: 'cert-submission-insurance-company-dropdown-menu',
  certSubmissionInsuranceCompanyDropdownMenuSearchInput: 'cert-submission-insurance-company-dropdown-menu-search-input',
  certSubmissionInsuranceCompanyDropdownMenuOption: id => `cert-submission-insurance-company-dropdown-menu-item_id-${id}`,
  subrogationWaivedCheckbox: 'cert-submission-subrogation-waived-checkbox',
  additionalInsuredCheckbox: 'cert-submission-additional-insured-checkbox',
  getPolicyTypePropertyCheckbox: propertyId => `cert-submission-policy-type-property-checkbox_property-${propertyId}`,
  getPolicyTypePropertyInput: propertyId => `cert-submission-policy-type-property-input_property-${propertyId}`,
  certSubmissionBackPolicyButton: 'cert-submission-back-policy-button',
  certSubmissionSkipPolicyButton: 'cert-submission-skip-policy-button',
  certSubmissionNextPolicyButton: 'cert-submission-next-policy-button',
  certSubmissionConfirmLanguageCheckbox: 'cert-submission-confirmation-language-checkbox',
  certSubmissionSubmitCertificateButton: 'cert-submission-submit-certificate-button',
  certEmailInput: 'agent-cert-email-email-input',
  certValidateEmailButton: 'agent-cert-validate-email-button',
  certStartSubmissionButton: 'agent-cert-start-submission-button',
  certRedirectError: 'agent-cert-redirect-error',
  certRedirectRetryButton: 'agent-cert-redirect-retry-button',
  certAgentDetailsFirstNameInput: 'agent-cert-agent-details-first-name-input',
  certAgentDetailsLastNameInput: 'agent-cert-agent-details-last-name-input',
  certAgentDetailsPhoneInput: 'agent-cert-agent-details-phone-input',
  certAgentDetailsCreateAgencyButton: 'agent-cert-agent-details-create-agency-button',
  certAgentDetailsCreateAgencySubmitButton: 'agent-cert-agent-details-create-agency-submit-button',
  certAgentDetailsLicenseInput: 'agent-cert-agent-details-license-input',
  certAgentDetailsCompanyNameInput: 'agent-cert-agent-details-company-name-input',
  certAgentDetailsAddressInput: 'agent-cert-agent-details-address-input',
  certAgentAgencyCheckbox: id => `agent-cert-agent-details-agency-checkbox-id-${id}`,
  certAgentAgencyNextButton: 'agent-cert-agent-details-agency-next-button',
  certUploadDocFileButton: 'agent-cert-upload-doc-file-button',
  certUploadDocDynamicFileInput: 'agent-cert-upload-doc-dynamic-file-input',
  certDocTypeCheckbox: docTypeId => `agent-cert-upload-doc-type-checkbox-type-${docTypeId}`,
  certDocPolicyLinkCheckbox: policyTypeId => `agent-cert-upload-doc-policy-link-checkbox-policy-type-${policyTypeId}`,
  certDocAddAdditionalPoliciesButton: 'agent-cert-doc-add-additional-policies-button',
  certDocAddAdditionalPolicies: policyTypeId => `agent-cert-doc-add-additional-policies-type-${policyTypeId}`,
  certDocSubmitButton: 'agent-cert-doc-submit-button',
  certUploadContinueButton: 'agent-cert-upload-continue-button',
  // portal/general
  closeModalButton: 'close-modal-button',
  closeToastButton: status => `close-toast-button-${status}`,
  successToast: 'toast-success',
  errorToast: 'toast-error',
  warningToast: 'toast-warning',
  infoToast: 'toast-general',
  understandIrreversibleCheckbox: 'understand-irreversible-checkbox',
  stackedButtonPrimaryOption: 'stacked-button-primary-option',
  stackedButtonSecondaryOption: 'stacked-button-secondary-option',
  confirmDontAskAgainButton: 'confirm-dont-ask-again-button',
  // projects page
  listProjectsSearchLoading: 'list-projects-search-loading',
  listProjectsSearchLoaded: 'list-projects-search-loaded',
  listProjectsCreateProjectButton: 'list-projects-create-project-button',
  createProjectTrayProjectNameInput: 'create-project-tray-project-name-input',
  createProjectTrayProjectNumberInput: 'create-project-tray-project-number-input',
  createProjectTrayDefaultRequirementsDropdown: 'create-project-tray-default-requirements-dropdown',
  createProjectTraySubmitButton: 'create-project-tray-submit-button',
  exportProjectsExcelButton: 'export-projects-excel-button',
  // project details page
  projectDetailsCreateRecordButton: 'project-details-create-record-button',
  createRecordTrayCreateNewInsuredTab: 'create-record-tray-create-new-insured-button',
  createRecordTrayInsuredNameInput: 'create-record-tray-insured-name-input',
  createRecordTrayInsuredEmailInput: 'create-record-tray-insured-email-input',
  createRecordTrayCreateInsuredSubmitButton: 'create-record-tray-create-insured-submit-button',
  createRecordTraySubmitButton: 'create-record-tray-submit-button',
  createRecordTrayApplyProjectDefaultRequirementTemplateToggleButton: 'create-record-tray-apply-project-default-requirement-template-toggle-button',
  projectDetailsRecordRowByName: name => `project-details-record-row-${snakeCase(name)}`,
  exportProjectDetailsPageExcelButton: 'export-project-details-page-excel-button',
  editProjectDetailsButton: 'edit-project-details-button',
  saveProjectDetailsButton: 'save-project-details-button',
  projectNameFormInput: 'project-name-form',
  projectRequirementTemplateDisplay: 'project-requirement-template-display',
  // insureds page
  listInsuredsSearchInput: 'list-insureds-search-input',
  listInsuredsRow: name => `list-insureds-row-${snakeCase(name)}`,
  insuredsSaveNewInsuredButton: 'insureds-save-new-insured-button',
  insuredsSkipAddToProjectButton: 'insureds-skip-add-to-project-button',
  // req template dropdown
  reqTemplateMenuButton: 'requirement-templates-dropdown-menu-button',
  reqTemplateSearchInput: 'requirement-templates-dropdown-search-input',
  reqTemplateGetFolderOptionByName: folderName => `requirement-templates-dropdown-folder-option_folder-name-${snakeCase(folderName)}`,
  reqTemplateGetTemplateOptionByName: templateName => `requirement-templates-dropdown-template-option_template-name-${snakeCase(templateName)}`,
  reqTemplateResetButton: 'requirement-templates-dropdown-reset-button',
  reqTemplateUploadContractButton: 'requirement-templates-dropdown-upload-contract-button',
  extractedTemplateUseTemplateButton: 'extracted-template-use-template-button',
  extractedTemplateEditInBuilderButton: 'extracted-template-edit-in-builder-button',
  extractedTemplateSaveToLibraryCheckbox: 'extracted-template-save-to-library-checkbox',
  extractedTemplateKeepEditingButton: 'extracted-template-keep-editing-button',
  extractedTemplateDiscardButton: 'extracted-template-discard-button',
  extractedTemplateConfirmDiscardButton: 'extracted-template-confirm-discard-button',
  // req templates page
  reqTemplatesPageHeader: 'req-templates-page-header',
  reqTemplatesCreateNewFolderButton: 'req-templates-create-new-folder-button',
  reqTemplatesCreateNewFolderInput: 'req-templates-create-new-folder-input',
  reqTemplatesCreateNewFolderSubmitButton: 'req-templates-create-new-folder-submit-button',
  reqTemplatesFolderTabByName: folderName => `req-templates-folder-option_folder-name-${snakeCase(folderName)}`,
  reqTemplatesFolderSubMenuButton: folderName => `${CypressIds.reqTemplatesFolderTabByName(folderName)}-menu`,
  reqTemplateFolderTabSubMenuRenameFolder: folderName => `${CypressIds.reqTemplatesFolderSubMenuButton(folderName)}-rename_folder`,
  reqTemplateFolderTabSubMenuDeleteFolder: folderName => `${CypressIds.reqTemplatesFolderSubMenuButton(folderName)}-delete_folder`,
  reqTemplatesCreateNewTemplateButton: 'req-templates-create-new-template-button',
  reqTemplatesCreateNewTemplateFromScratchButton: 'req-templates-create-new-template-from-scratch-button',
  reqTemplatesCreateNewTemplateFromTemplateButton: 'req-templates-create-new-template-from-template-button',
  reqTemplatesCreateNewTemplateFromContractButton: 'req-templates-create-new-template-from-contract-button',
  reqTemplatesSelectTemplateRowByName: templateName => `req-templates-select-template-row_template-name-${snakeCase(templateName)}`,
  reqTemplatesSearchInputGroup: 'req-templates-search-input-group',
  reqTemplatesPublishTemplateButton: 'req-templates-publish-template-button',
  reqTemplatesSaveTemplateModalTemplateNameInput: 'req-templates-save-template-modal-template-name-input',
  reqTemplatesSaveTemplateModalTemplateFolderDropdown: 'req-templates-save-template-modal-template-folder-dropdown',
  reqTemplatesSaveTemplateModalTemplateFolderDropdownOption: folderName => `${CypressIds.reqTemplatesSaveTemplateModalTemplateFolderDropdown}-option-${snakeCase(folderName)}`,
  reqTemplatesGetTemplateRowByName: templateName => `req-templates-get-template-row_template-name-${snakeCase(templateName)}`,
  reqTemplatesGetTemplateRowByNameMenu: templateName => `${CypressIds.reqTemplatesGetTemplateRowByName(templateName)}-menu`,
  reqTemplatesGetTemplateRowByNameMenuDetails: templateName => `${CypressIds.reqTemplatesGetTemplateRowByNameMenu(templateName)}-template_details`,
  reqTemplatesTemplateDetailsNameInput: 'req-templates-template-details-name-input',
  reqTemplatesEditQuestionCategoryNameInput: 'req-templates-edit-question-category-name-input',
  // custom questions
  createCustomQuestionButton: 'create-custom-question-button',
  customQuestionNameInput: 'custom-question-name-input',
  customQuestionDescriptionInput: 'custom-question-description-input',
  customQuestionRedFlagSwitch: 'custom-question-red-flag-switch',
  customQuestionCategoryDropdown: 'custom-question-category-dropdown',
  customQuestionCreateCategoryButton: 'custom-question-create-category-button',
  customQuestionNewCategoryNameInput: 'custom-question-new-category-name-input',
  customQuestionSaveButton: 'custom-question-save-button',
  editQuestionModalCreateNewCategoryButton: 'edit-question-create-new-category-button',
  editQuestionModalCreateNewCategoryInput: 'edit-question-create-new-category-input',
  editQuestionModalNameInput: 'edit-question-modal-name-input',
  editQuestionModalDescriptionInput: 'edit-question-modal-description-input',
  editQuestionModalRedFlagSwitch: 'edit-question-modal-red-flag-switch',
  editQuestionModalRetroactiveCheckbox: 'edit-question-modal-retroactive-checkbox',
  editQuestionModalSaveButton: 'edit-question-modal-save-button',
  editQuestionModalCancelButton: 'edit-question-modal-cancel-button',
  questionCategoryOptionsButton: questionCategoryId => `question-category-options-button-${questionCategoryId}`,
  questionOptionsButton: questionId => `question-options-button-${questionId}`,
  questionEditOption: questionId => `${CypressIds.questionOptionsButton(questionId)}-edit_custom_question`,
  questionDeleteOption: questionId => `${CypressIds.questionOptionsButton(questionId)}-delete_custom_question`,
  questionCategoryEditOption: questionCategoryId => `${CypressIds.questionCategoryOptionsButton(questionCategoryId)}-edit_category_name`,
  questionCategoryDeleteOption: questionCategoryId => `${CypressIds.questionCategoryOptionsButton(questionCategoryId)}-delete_category`,
  editQuestionCategorySaveButton: 'edit-question-category-save-button',
  editQuestionCategoryCancelButton: 'edit-question-category-cancel-button'
};
